import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";

export const TitleSection = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(1),
  color: theme.palette.institutional.braskemGray,
  marginLeft: "100px",
  marginRight: "100px"
}));
